<template>
	<div class="card" @click="$emit('click')">
		<div style="height:42px">
			<i :class="icon"></i>
		</div>
		<div class="name">{{ name }}</div>
	</div>
</template>

<script>
export default {
	name: 'ComponentCard',
	props: {
		icon: String,
		name: String
	}
}
</script>

<style scoped>
.card {
	display: flex;
	flex-direction: column;
	justify-content: center;
	float: left;
	width: 80px;
	height: 80px;
	padding: 20px 0px;
	border: 1px dotted #e1e1e1;
	text-align: center;
	cursor: pointer;
	color: #687382;
}

.card:hover {
	background-color: #eff2f7;
	color: #58b7ff;
}

.card i {
	font-size: 30px;
	font-weight: 100;
}

.name {
	font-size: 14px;
	font-weight: normal;
	height: 20px;
	line-height: 20px;
	margin: 0;
}
</style>
